import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import { makeStyles } from '@material-ui/core/styles';
import LAOGlobalContext from 'context/LAOGlobalContext';
import ErrorHandlerPage from 'components/common/ErrorHandlerPage';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(10),
    position: 'relative',
    height: '100%',
    [theme.breakpoints.up('xs')]: {
      marginRight: theme.spacing(0),
      marginLeft: theme.spacing(0),
    },
    // background: theme.palette.primary.base
  },
  body: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2),
      marginTop: theme.spacing(1),
    }
  }
}));

const LaoKPIMainLayout = ({ component, region }) => {

  const classes = useStyles();
  const { t } = useTranslation();
  const [memoizedValue, setMemoizedValue] = useState(null);
  const { locations_err } = useSelector(({ laoSites }) => laoSites);
  const language = localStorage.getItem('i18nextLng');

  useDeepCompareEffect(() => {
      setMemoizedValue({
        language
      });

  }, [language]);

  return (
    <div data-testid="laoKPImainlayout" className={classes.root}>
      {
        locations_err
          ? <ErrorHandlerPage errTagline={locations_err === 'lao_restricted' ? t("we_are_sorry") : null} errMessage={t(locations_err)} />
          : <>
            <LAOGlobalContext.Provider value={memoizedValue}>
              {memoizedValue && <>
                <div className={classes.body} >
                  {component}
                </div>
              </>}
            </LAOGlobalContext.Provider>
          </>
      }
    </div>
  )
}

export default LaoKPIMainLayout;